/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

export { subscribe, createSourceEventStream } from './subscribe';


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/subscription/index.mjs
// module id = 1007
// module chunks = 0